import React from 'react';
import logo from "../assets/images/logos/icon-fiskagroup.png"

function Loading() {
    return (
        <div className="relative flex justify-center items-center">
            <div className="absolute animate-spin rounded-full h-32 w-32 border-t-4 border-b-4 border-main"></div>
            <img src={logo} width={"100px"} height={"78px"} alt="Icone du logo de FISKA\Group" />
        </div>
    );
}

export default Loading;